
<script setup lang="ts">
import { useHead } from "@vueuse/head"
  const head = {"title":"Informacje Prawne | Sigma Clinic","meta":[{"property":"og:title","content":"Informacje Prawne | Sigma Clinic"},{"property":"og:description","content":"Informacje prawne i dane firmy Sigma Clinic."},{"name":"description","content":"Informacje prawne i dane firmy Sigma Clinic."}]}
  useHead(head)
  const title = "Informacje Prawne | Sigma Clinic"
 const description = "Informacje prawne i dane firmy Sigma Clinic."
 const excerpt = undefined
 const meta = [{"property":"og:title","content":"Informacje Prawne | Sigma Clinic"},{"property":"og:description","content":"Informacje prawne i dane firmy Sigma Clinic."},{"name":"description","content":"Informacje prawne i dane firmy Sigma Clinic."}]
  defineExpose({ frontmatter: {"title":"Informacje Prawne | Sigma Clinic","description":"Informacje prawne i dane firmy Sigma Clinic.","meta":[{"property":"og:title","content":"Informacje Prawne | Sigma Clinic"},{"property":"og:description","content":"Informacje prawne i dane firmy Sigma Clinic."},{"name":"description","content":"Informacje prawne i dane firmy Sigma Clinic."}]}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {"title":"Informacje Prawne | Sigma Clinic","description":"Informacje prawne i dane firmy Sigma Clinic.","meta":[{"property":"og:title","content":"Informacje Prawne | Sigma Clinic"},{"property":"og:description","content":"Informacje prawne i dane firmy Sigma Clinic."},{"name":"description","content":"Informacje prawne i dane firmy Sigma Clinic."}]}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>Informacje Prawne</h1>
<p>Ostatnia aktualizacja: 16 października 2025</p>
<h3>Operator:</h3>
<p><strong>Sigma Clinic sp. z o.o.</strong></p>
<p>Adres: Młynarska 42, 01-171 Warszawa, Polska<br>
KRS: 0001184102 • NIP (VAT): 5273173475<br>
Numer rejestrowy RPWDL: 000000294316</p>
<p>Email: kontakt@sigma.clinic</p>
</div>
</template>
